import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import PublicIcon from "@mui/icons-material/Public";
import GroupsIcon from "@mui/icons-material/Groups";
import BadgeIcon from "@mui/icons-material/Badge";
import { Localize } from "../../../app/lang/langs";
import { NEWS_AUDIENCE_ALL, NEWS_AUDIENCE_COLLABS } from "../../../app/utils/config";

/**
 * Who a post went to, read off what the feed returns: `audience` ('all' | 'custom') plus
 * `audience_targets`, the rows the backend batches onto every news item.
 *
 * Shown to every reader, not only the author: a broadcast's audience is a label on the
 * post, and the reader is by definition inside it.
 */
export default function NewsAudienceChips({ news, size = "small" }) {

    if (!news) return null

    const targets = news.audience === NEWS_AUDIENCE_ALL || !news.audience
        ? [{ target: NEWS_AUDIENCE_ALL }]
        : (news.audience_targets || [])

    if (!targets.length) return null

    const labelFor = (target) => {
        if (target.target === NEWS_AUDIENCE_ALL) return Localize("NEWS_AUDIENCE_ALL")
        if (target.target === NEWS_AUDIENCE_COLLABS) return Localize("NEWS_AUDIENCE_COLLABS")
        return target.name || ""
    }

    const iconFor = (target) => {
        const sx = { fontSize: 15 }
        if (target.target === NEWS_AUDIENCE_ALL) return <PublicIcon sx={sx} />
        if (target.target === NEWS_AUDIENCE_COLLABS) return <GroupsIcon sx={sx} />
        return <BadgeIcon sx={sx} />
    }

    return (
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.5 }}>
            <Typography sx={{ fontSize: "0.75rem", color: "#6b6560", mr: 0.5 }}>
                {Localize("NEWS_AUDIENCE")}
            </Typography>
            {targets.map((target, index) => (
                <Chip
                    key={`${target.target}_${target.id_manager_profile ?? index}`}
                    size={size}
                    icon={iconFor(target)}
                    label={labelFor(target)}
                    sx={{
                        fontWeight: 600,
                        fontSize: "0.7rem",
                        color: "#002880",
                        backgroundColor: "rgba(0, 40, 128, 0.07)",
                        border: "1px solid rgba(0, 40, 128, 0.16)",
                        "& .MuiChip-icon": { color: "#002880" },
                    }}
                />
            ))}
        </Box>
    )
}
